import React from 'react'
import styles from './ProfileIncompleteCTA.module.scss'
import Icon, { Icons } from '@crystal-eyes/components/elements/Icon/Icon'

export default function ProfileIncompleteCTA({
  title,
  subtext,
  CTA,
  action,
}: {
  title: string
  subtext: string
  CTA: string
  action: () => void
}) {
  return (
    <div className={`${styles.completenessBox}`}>
      <div className={styles.assessmentHeader}>
        <Icon icon={Icons.Disc} className={styles.icon} />
        <div>{title}</div>
      </div>
      <div className="CE subtext">{subtext}</div>
      <button onClick={action} className={`CE action-button secondary`}>
        {CTA}
      </button>
    </div>
  )
}
